import { getCountryLanguage, getStoreId } from "../BasePathTools";
import oauthFetch from "@inditex/ecomfront-oauth-fetch";
import { isMarketWithoutOuth } from "../utils";
import { getEnv } from "../EnvironmentTools";

const isEnableForCurrentAPI = (url: string) => {
  return !([getEnv()?.resellApiHost].some((apiPath: string) => url.includes(apiPath)));
};

const getOauthOptions = (config) => {
  return {
    enabled: !isMarketWithoutOuth(getStoreId()?.toString()) && isEnableForCurrentAPI(config?.url),
    storeId: getStoreId(),
    refreshPath: `${getCountryLanguage()}user/oauth2/refresh`,
  };
};

const createFetchOptions = (config) => {
  const fetchOptions: RequestInit = {
    method: config?.method?.toLocaleUpperCase() ?? "",
    headers: { ...config?.headers },
  };

  if (config?.method !== "GET" && config?.method !== "HEAD") {
    fetchOptions.body = config.data ?? undefined;
    if (fetchOptions.body instanceof FormData) {
      delete (fetchOptions.headers as Record<string, string>)['Content-Type'];
    }
  }

  return fetchOptions;
};

const parseResponseBody = async (response: Response) => {
  try {
    return await response?.json();
  } catch (error) {
    return null;
  }
};

const handleResponse = async (response: Response, config) => {
  const data = await parseResponseBody(response);

  if (!response.ok) {
    return Promise.reject({
      response: {
        status: response.status,
        statusText: response.statusText,
        data,
      },
    });
  } else {
    return {
      ...config,
      data,
      adapter: () =>
        Promise.resolve({
          data,
          status: response.status,
          statusText: response.statusText,
          headers: {},
          config,
          request: {},
        }),
    };
  }
};

export const oauthInterceptor = async (config) => {
  const fetchOptions = createFetchOptions(config);
  const oauthConfig = getOauthOptions(config)
  const response = (await oauthFetch( config.url as string, fetchOptions, oauthConfig)) as Response;
  return handleResponse(response, config);
};
